import React, {useEffect, useState} from 'react';
import numberFormat from "../../../helpers/numberFormat";
import {Form, Row, Tab, Table, Tabs} from "react-bootstrap";
import {Link} from "react-router-dom";
import {AirBookingEditRoute, TouristServicesEditRoute} from "../../routesConstants";
import GoogleDisc from "../../../components/svg/GoogleDisc";
import LoadingButton from "../../base/components/loadingButton";
import axios from "../../../helpers/axios";
import _ from "lodash";
import AddRowsToGoogleButton from "./addRowsToGoogleButton";
import {GROUP_ROUTE_TYPE} from "./GroupForm";
import ServiceQuickEditModal from "./serviceQuickEditModal";

const RegistersReviceTabs = ({info, onReload}) => {
  const [showLinks, setShowLinks] = useState(false)
  const [showKrs, setShowKrs] = useState(false)
  const [disabledButton, setDisabledButton] = useState(false)
  const [disabledAll, setDisabledAll] =useState(false)
  const [editRow, setEditRow] = useState(null)

  const data = info.data
  const lockInsertButtons = (mode) => {
    if (mode === 'start' || mode === 'all-done') {
      setDisabledButton(true)
      setDisabledAll(true)
    } else if (mode === 'sheet-done') {
      setDisabledButton(true)
      setDisabledAll(false)
    } else {
      setDisabledButton(false)
      setDisabledAll(false)
    }
  }
  useEffect(() => {
    lockInsertButtons('reset')
  }, [info]);


  return (
    <>
      <div className={'d-flex justify-content-between'}>
        <Form.Label className={'d-flex align-items-center gap-2'}>
          <input
            defaultChecked={showLinks}
            checked={showLinks}
            onChange={(e) => {
              setShowLinks(!showLinks)
            }}
            type={"checkbox"}
          />{" "}
          Показать ссылки
        </Form.Label>
        <Link to={'https://docs.google.com/spreadsheets/d/'+info.group.googleSheetId} target={'_blank'}>
          <div className={'d-flex gap-2 pointer'}>
            <GoogleDisc/>
            <div>Ссылка на таблицу</div>
          </div>
        </Link>

      </div>

      <Row>
        <Tabs defaultActiveKey="correct">
          <Tab
            eventKey="correct"
            title={<div>
              Правильные ({data.correct.length})
              {_.find(data.correct, {krsTotal: 3300}) && <i className="fa fa-exclamation-circle text-danger ml-2"/>}
            </div>}
          >
            <Table striped hover>
              {renderHeader()}
              {renderStandartBody(data.correct, showLinks, false, false, false, null, setEditRow)}
            </Table>
          </Tab>
          <Tab
            eventKey="noRegister"
            title={`Есть в Kayar но нет в Google (${data.registerMissing.length})`}
          >
            <Table striped hover>
              {renderHeader()}
              {renderStandartBody(data.registerMissing, showLinks, false, false, false, null, setEditRow)}
            </Table>
          </Tab>
          <Tab
            eventKey="noKayar"
            title={`Есть в Google но нет в Kayar (${data.kayarMissing.length})`}
          >
            <Table striped hover>
              {renderHeader()}
              {renderStandartBody(data.kayarMissing, showLinks, false, false, false, null, setEditRow)}
            </Table>
          </Tab>
          <Tab
            eventKey="diff"
            title={`Отличаются (${data.diff.length})`}
          >
            <Table striped bordered hover>
              <thead>
              <tr>
                <td rowSpan={2}>№</td>
                <td rowSpan={2}>Номер</td>
                <td rowSpan={2}>Пассажир</td>
                <td rowSpan={2}>Описание</td>
                <td rowSpan={2}>Выписан Google</td>
                <td rowSpan={2}>Выписан Kayar</td>
                <td className={'text-center'} colSpan={3}>
                  Итог
                </td>
              </tr>
              <tr className={'text-center'} >
                <td>Google</td>
                <td>Kayar</td>
                <td>Разница</td>
              </tr>
              </thead>
              <tbody>
              {data.diff.map((u, index) => {
                return (
                  <tr key={index}>
                    <td>{u.index}</td>
                    <td style={{minWidth:150}}>{showLinks && u.siteId ?
                      <Link
                      to={`${u.itemType === 'SRV' ? TouristServicesEditRoute : AirBookingEditRoute}${u.siteId}`}
                      target={'_blank'}>{u.itemNumber}{u.refund ? '-В':''}</Link> :
                      `${u.itemNumber}${u.refund ? '-В': ''}`}</td>
                    <td>{u.itemType === 'CASH' || u.itemType === 'BANK' ? typeTranslate[u.itemType] : u.paxName}</td>
                    <td>{u.description}</td>
                    {typeof u.issueDate === 'string' ?
                      <td colSpan={2} className={'text-center'}>{u.issueDate}</td> :
                      <>
                        <td>{u.issueDate.register}</td>
                        <td>{u.issueDate.kayar}</td>
                      </>}
                    {renderValue(u.total)}
                  </tr>
                );
              })}
              <tr>
                <td colSpan={8}>Итого разница:</td>
                <td>{numberFormat(_.sumBy(data.diff, (i)=>{
                  if(typeof i.total === 'number'){
                    return i.total
                  } else{
                    return i.total.kayar-i.total.register
                  }
                }))}</td>
              </tr>
              </tbody>
            </Table>
          </Tab>
          <Tab
            eventKey="unrecognized"
            title={`Нераспознаные (${data.unrecognized.length})`}
          >
            <Table striped hover>
              {renderHeader()}
              {renderStandartBody(data.unrecognized, showLinks, false, false, false, null, setEditRow)}
            </Table>
          </Tab>
          {data.kayarDuplicates.length>0 && <Tab
            eventKey="kayarDuplicates"
            title={`Дубли в Каяр (${data.kayarDuplicates.length})`}
          >
            <Table striped hover>
              {renderHeader(false, false)}
              {data.kayarDuplicates.map((array, index)=>{
                return <React.Fragment key={index}>
                  {renderStandartBody(array, showLinks, false, false, false, null, setEditRow)}
                </React.Fragment>
              })}
            </Table>
          </Tab>}
          {data.registerDuplicates.length>0 && <Tab
            eventKey="registerDuplicates"
            title={`Дубли в Реестре (${data.registerDuplicates.length})`}
          >
            <Table striped hover>
              {renderHeader(false, true)}
              {data.registerDuplicates.map((array, index)=>{
                return <React.Fragment key={index}>
                  {renderStandartBody(array, showLinks, false, false, true, null, setEditRow)}
                </React.Fragment>
              })}

            </Table>
          </Tab>}
          {data.wrongDateGoogleRows.length> 0 && <Tab
            eventKey="wrongDateGoogleRows"
            title={`Есть в Google но не попадают в период (${data.wrongDateGoogleRows.length})`}
          >
            <Table striped hover>
              {renderHeader(false,true)}
              {renderStandartBody(data.wrongDateGoogleRows, showLinks, false, false, true, null, setEditRow)}
            </Table>
          </Tab>}
          {data.wrongList.length>0 && <Tab
            eventKey="wrongList"
            title={`Не на том листе (${data.wrongList.length})`}
          >
            <Table striped hover>
              <Table striped bordered hover>
                <thead>
                <tr>
                  <td rowSpan={2}>Номер</td>
                  <td rowSpan={2}>Пассажир</td>
                  <td rowSpan={2}>Описание</td>
                  <td rowSpan={2}>Оригинальный контрагент</td>
                  <td rowSpan={2}>На Листе</td>
                  <td className={'text-center'} colSpan={3}>
                    Итог
                  </td>
                </tr>
                <tr className={'text-center'} >
                  <td>Google</td>
                  <td>Kayar</td>
                  <td>Разница</td>
                </tr>
                </thead>
                <tbody>
                {data.wrongList.map((u, index) => {
                  return (
                    <tr key={index}>
                      <td style={{minWidth: 150}}>{showLinks && u.siteId ? <Link
                        to={`${u.itemType === 'SRV' ? TouristServicesEditRoute : AirBookingEditRoute}${u.siteId}`}
                        target={'_blank'}>{u.itemNumber}{u.refund ? '-В' : ''}</Link> : `${u.itemNumber}${u.refund ? '-В' : ''}`}</td>
                      <td>{u.itemType === 'CASH' || u.itemType === 'BANK' ? typeTranslate[u.itemType] : u.paxName}</td>
                      <td>{u.description}</td>
                      <td>{_.find(info.group.counterparties,{counterpartyCode: u.counterpartyCode.kayar})?.clientName||info.group.counterparties}</td>
                      <td>{u.sheetTitle}</td>
                      {renderValue(u.total)}
                    </tr>
                  );
                })}
                </tbody>
              </Table>
            </Table>
          </Tab>}

          {data.past && <Tab
            eventKey="toGoogle"
            title={`Для вставки(${data.past.length})`}
          >
            <div className={'d-flex justify-content-between align-items-center'}>
              <Form.Label className={'d-flex align-items-center gap-2'}>
                <input
                  defaultChecked={showKrs}
                  onChange={()=>setShowKrs(!showKrs)}
                  type={"checkbox"}
                />{" "}
                Показать колонку "Крс"
              </Form.Label>
              {data.past.length >0 && <AddRowsToGoogleButton info={info}
                                                             disabledButton={disabledButton}
                                                             cb={lockInsertButtons}
                                                             textTitle={"Вставить все"}/>}
            </div>

            {showKrs && <div className={'text-danger text-center'}>Копирование вместе с крс недоступно!Выключите показ крс</div>}
            <Tabs defaultActiveKey={'0'}>
              {data.past.map((list, index)=>{
                return <Tab eventKey={index.toString()}
                            title={`Лист ${list.name} (${list.tableData.length})`}
                            key={index}>
                  <div className={'d-flex justify-content-end mb-2'}>
                    <AddRowsToGoogleButton info={info}
                                           list={list}
                                           disabledButton={disabledAll}
                                           cb={lockInsertButtons}
                                           textTitle={"Вставить только этот лист"}/>
                  </div>

                  <Table bordered className={showKrs ? 'user-select-none' : ''}>
                    {renderStandartBody(list.tableData, showLinks, true, showKrs, false, info.group, setEditRow)}
                  </Table>
                </Tab>
              })}
            </Tabs>
          </Tab>}
        </Tabs>
      </Row>
      {editRow && <ServiceQuickEditModal
        row={editRow}
        onHide={() => setEditRow(null)}
        onSaved={onReload}
      />}
    </>
  );
};

export default RegistersReviceTabs;

const renderHeader = (source, showRow) => {
  return <thead>
  <tr>
    {showRow && <td>Строка</td>}
    <td>Выписан</td>
    <td>Тип</td>
    <td>Пассажир</td>
    <td>Номер</td>
    <td>Описание</td>
    <td>Итого</td>
    <td>Дата услуги</td>
  </tr>
  </thead>
}

export const typeTranslate = {
  'TKT' :'Авиа',
  'SRV':'Услуга',
  'BANK':'Оплата',
  'CASH':'Оплата',
  'TAX' : 'Комиссия',
  'UNRECOGNIZED' : 'Нераспознаное'
}
const renderStandartBody = (array, showLinks, withoutSpace, showKrs, showRow, group, onEdit) =>{
  return <tbody style={{color:"black"}}>
  {array.map((u, index) => {
    const krs3300 = Math.floor(u.krsTotal) === 3300 && u.itemType === 'SRV'
    const style = krs3300 ? {backgroundColor:'rgba(255,0,0,0.22)'} : {}
    let description = u.description
    if(u.itemType === "TKT" && !!group){
      description = u[_.find(GROUP_ROUTE_TYPE, {value: group.routeType}).nameInObject]
    }
    return (
      <tr key={index} style={style}>
        {showRow && !!u.index && <td>{u.index}</td>}
        <td>{showLinks && u.siteId ?
          <Link to={`${u.itemType === 'SRV' ? TouristServicesEditRoute:AirBookingEditRoute}${u.siteId}`}
                target={'_blank'}>{u.issueDate}</Link>
          : u.issueDate}</td>
        <td>{typeTranslate[u.itemType]}</td>
        <td>{u.paxName}</td>
        <td style={{minWidth:150}}>
          <>{u.itemNumber}{u.refund && !u.type !== "SRV" ? '-В' : ''}</>
          {krs3300 && u.siteId && <i
            className="fa fa-pencil text-primary ml-2 text-black"
            style={{cursor: 'pointer'}}
            onClick={() => onEdit({
              siteId: u.siteId,
              itemNumber: u.itemNumber,
              description
            })}
          />}
          {u.duplicate && <><br/><div className={'text-danger'}>ДУБЛИКАТ</div></>}
        </td>
        <td>{description}</td>
        {showKrs && <td className={'text-end'}>{u.krsTotal}</td>}
        <td className={'text-end'}>{withoutSpace ? u.total?.toString().replaceAll('.',',') : numberFormat(u.total)}</td>
        <td>{u.itemDate}</td>
      </tr>
    );
  })
  }
  {!showRow && <tr>
    <td colSpan={5}>
      <b>Итого</b>
    </td>
    {showKrs && <td className={'text-end'}>
      <b>{numberFormat(_.sumBy(array, u => Number(u.krsTotal) || 0))}</b>
    </td>}
    <td className={'text-end'}>
      <b>
        {numberFormat(
          array
            .map(u => u.total)
            .reduce((a, b) => a + b, 0)
        )}
      </b>
    </td>
    <td></td>
  </tr>}
  </tbody>

}

const renderValue = (value) =>{
  if(typeof value !== 'object'){
    return <td className={'text-center'} colSpan={3}>{numberFormat(value)}</td>
  }else{
    return <>
      <td className={'text-center'}>{numberFormat(value.register)}</td>
      <td className={'text-center'}>{numberFormat(value.kayar)}</td>
      {/*<td className={'text-center'} >{numberFormat(Math.abs(value.register-value.kayar))}</td>*/}
      <td className={'text-center'}>{numberFormat(value.kayar-value.register)}</td>
    </>
  }
}
